import { render, staticRenderFns } from "./Engagement.vue?vue&type=template&id=89f2a76c&scoped=true&"
import script from "./Engagement.vue?vue&type=script&lang=js&"
export * from "./Engagement.vue?vue&type=script&lang=js&"
import style0 from "./Engagement.vue?vue&type=style&index=0&id=89f2a76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f2a76c",
  null
  
)

export default component.exports